// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2FIM4","info":"PatientInfo_info__26NAe"};